import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import { ApplicationService } from '../service'
import { AuthService } from '../../auth/service'
import type { ApplicationState } from './types'
import { GET_APPLICATION, GET_LIST_APPLICATIONS, GET_APPLICATION_LOGS_IN_WEEK } from './types'
import orderBy from 'lodash/orderBy'
import type { IApplicationParams } from 'interfaces'

const applicationService = new ApplicationService()
const authService = new AuthService()
export const actions: ActionTree<ApplicationState, RootState> = {
  actGetListApplications({ commit }, params: object) {
    return applicationService.getListApplications(params).then((apps) => {
      const transform = orderBy(apps, [(a) => new Date(a.updatedAt)], ['desc'])
      commit(GET_LIST_APPLICATIONS, transform)
      return transform
    })
  },
  actCreateApplication(_, params: object) {
    return applicationService.createApplication(params)
  },
  actUpdateApplication(_, params: IApplicationParams) {
    return applicationService.updateApplication(params)
  },
  actDeleteApplication(_, params: IApplicationParams) {
    return applicationService.deleteApplication(params)
  },
  actGetDropdownApplication(_, params: IApplicationParams) {
    return applicationService.getListApplications(params)
  },
  actGetApplication({ commit }, params: IApplicationParams) {
    return applicationService.getApplication(params).then((app) => commit(GET_APPLICATION, app))
  },
  actGetConfigApplication(_, params: IApplicationParams) {
    return applicationService.getConfigApplication(params)
  },
  actCreateConfigApplication(_, params: IApplicationParams) {
    return applicationService.createConfigApplication(params)
  },
  actUpdateConfigApplication(_, params: IApplicationParams) {
    return applicationService.updateConfigApplication(params)
  },
  actCheckApplicationIsUsed(_, params: IApplicationParams) {
    return applicationService.checkApplicationIsUsed(params)
  },
  actGetApplicationLogsInWeek({ commit }, params: object) {
    return applicationService.getApplicationLogsInWeek(params).then((resp) => {
      commit(GET_APPLICATION_LOGS_IN_WEEK, resp)
      return resp
    })
  },
  actGetAccesToken(_, params: GetAccessToken) {
    return authService.getAccessToken(params)
  },
}
